import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from 'axios';

import { PURGE } from 'redux-persist';
import { headers, urls } from '../../libs/reqConf';
import { checkTokenAndRefresh, errorHandle } from '../../utils/function';
import { getCloseLoading, getLoading } from './loading';
import { setError } from './modal';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  homeData: {},
  isErrorModal: false,
  dialog: false
};

const slice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    homeReset(state) {
      // immer를 사용하여 직접 상태를 수정
      Object.assign(state, initialState);
    },
    // GET 홈데이터

    getHomeDataSuccess(state, action) {
      state.homeData = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { openModSelfPlan, closeModal, homeReset } = slice.actions;

// ----------------------------------------------------------------------
// home 데이터 조회
export function getHomeData() {
  return async (dispatch) => {
    let accessToken = window.localStorage.getItem('accessToken');
    dispatch(getLoading());
    accessToken = await checkTokenAndRefresh(dispatch);
    try {
      const url = `${urls.user}/home`;
      const config = { headers: headers(accessToken) };
      const response = await axios.get(url, config);

      dispatch(slice.actions.getHomeDataSuccess(response.data.data));
    } catch (error) {
      dispatch(setError(errorHandle(error)));
    } finally {
      dispatch(getCloseLoading());
    }
  };
}
